import withModal from 'src/hoc/withModal'

import PropositionDialog from './PropositionDialog'

export default withModal(PropositionDialog)
